<template>
  <input :value="csrfToken" type="hidden" name="csrfmiddlewaretoken" />
</template>

<script setup lang="ts">
import { getCsrfFromCookies } from '@/api/cookies'
import { ref, onMounted } from 'vue'
const csrfToken = ref<string | null>(null)

onMounted(() => {
  csrfToken.value = getCsrfFromCookies()
})
</script>
